/* Nine Line Solutions – premium interactions (reveal, count-up). Content is visible without JS. */
(function () {
  if (window.__nlpInit) return; window.__nlpInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el) {
    var raw = (el.getAttribute('data-nlp-count') || '').trim();
    if (!/^\d+$/.test(raw) || reduce) return;
    var end = parseInt(raw, 10), start = null, dur = 1400;
    el.textContent = '0';
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * e);
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }
  function init(root) {
    var els = (root || document).querySelectorAll('[data-nlp-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        en.target.querySelectorAll('[data-nlp-count]').forEach(countUp);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  document.documentElement.classList.add('nlp-js');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('beforeprint', function () { document.querySelectorAll('[data-nlp-reveal]').forEach(function (el) { el.classList.add('is-in'); }); });
})();
